import { render } from "./CDeposit.vue?vue&type=template&id=7961e586"
import script from "./CDeposit.vue?vue&type=script&lang=js"
export * from "./CDeposit.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__